/**
 * @typedef {Object} MatchListEntry
 * @property {string} matchId
 * @property {import('../types').OrchestrationState} orchestrationState
 * @property {number} displayOrdinal
 * @property {string | null} managerUid
 * @property {number} updatedAtMs
 */

/**
 * @typedef {Object} MatchListProjection
 * @property {string} competitionId
 * @property {MatchListEntry[]} matches
 * @property {number} updatedAtMs
 */

/**
 * @typedef {Object} ActiveHoldsProjection
 * @property {string} competitionId
 * @property {Record<string, string>} participantIdToMatchId
 * @property {Record<string, string>} resourceIdToMatchId
 * @property {number} updatedAtMs
 */

/**
 * @param {import('../match/matchTypes').MatchSummary} summary
 * @returns {MatchListEntry}
 */
export function matchSummaryToListEntry(summary) {
  return {
    matchId: summary.matchId,
    orchestrationState: summary.orchestrationState,
    displayOrdinal: summary.displayOrdinal,
    managerUid: summary.managerLease?.holderUid || null,
    updatedAtMs: Date.now(),
  };
}

/**
 * @param {MatchListProjection | null} current
 * @param {MatchListEntry} entry
 * @param {number} nowMs
 * @returns {MatchListProjection}
 */
export function upsertMatchListEntry(current, entry, nowMs) {
  const base = current || {
    competitionId: "",
    matches: [],
    updatedAtMs: nowMs,
  };
  const matches = [...(base.matches || []).filter((m) => m.matchId !== entry.matchId), entry].sort(
    (a, b) => a.displayOrdinal - b.displayOrdinal
  );
  return { ...base, matches, updatedAtMs: nowMs };
}

/**
 * @param {MatchListProjection} projection
 * @param {string} matchId
 * @param {number} nowMs
 */
export function removeMatchFromList(projection, matchId, nowMs) {
  return {
    ...projection,
    matches: (projection.matches || []).filter((m) => m.matchId !== matchId),
    updatedAtMs: nowMs,
  };
}
